import { createAppStore } from '@nackle/arcade-core';

export const appStore = createAppStore();
